import { Icon } from "@iconify/react/dist/iconify.js";

export const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      className="w-14 h-14 absolute right-[calc(3%_+_1px)] shadow-btn-3d bg-mainRed rounded-full flex justify-center items-center text-3xl text-mainWhite border border-bluredBlack"
      onClick={() => onClick()}
    >
      <span className="relative">
        <Icon icon={"octicon:chevron-right-12"} className="animate-ping z-10" />
        <Icon
          icon={"octicon:chevron-right-12"}
          className="absolute left-[0.7px] top-0"
        />
      </span>
    </button>
  );
};

export const CustomLeftArrow = ({ onClick }) => {
  return (
    <button
      className="w-14 h-14 absolute left-[calc(3%_+_1px)] shadow-btn-3d bg-mainRed rounded-full flex justify-center items-center text-3xl text-mainWhite border border-bluredBlack"
      onClick={() => onClick()}
    >
      <span className="relative">
        <Icon icon={"octicon:chevron-left-12"} className="animate-ping z-10" />
        <Icon
          icon={"octicon:chevron-left-12"}
          className="absolute right-[0.8px] top-0"
        />
      </span>
    </button>
  );
};
